import _regeneratorRuntime from "/app/node_modules/babel-runtime/regenerator";
import _JSON$stringify from "/app/node_modules/babel-runtime/core-js/json/stringify";
import _asyncToGenerator from "/app/node_modules/babel-runtime/helpers/asyncToGenerator";
import _extends from "/app/node_modules/babel-runtime/helpers/extends";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { required } from "vuelidate/lib/validators";
import { mapMutations, mapState } from "vuex";
import { stepForm } from "~/mixins";
import { currencyTypeEnum } from "~/enums";
import { ConflictError } from "~/abstractions/errors";
import { OnHoldError } from "~/api/errors";
import loader from "../modals/loader";
import PersonalDataTreatmentRadio from "./personal-data-treatment-radio";
import comisions from "../shared/table/comisions-table";
export default {
  components: {
    loader: loader,
    PersonalDataTreatmentRadio: PersonalDataTreatmentRadio,
    comisions: comisions
  },
  mixins: [stepForm],
  data: function data() {
    var authorizePersonalDataTreatment = this.$store.state.affiliations.form.afilliationSummary.authorizePersonalDataTreatment;


    return {
      authorizePersonalDataTreatment: authorizePersonalDataTreatment,
      dialog: false,
      tableComision: false,
      messageModal: 'Procesando Afiliación'
    };
  },

  validations: {
    authorizePersonalDataTreatment: { required: required }
  },
  computed: _extends({}, mapState({
    posSelected: function posSelected(state) {
      return state.affiliations.form.posSelected;
    },
    commercialTariffResults: function commercialTariffResults(state) {
      return state.affiliations.form.commercialTariffResults;
    },
    paymentData: function paymentData(state) {
      return state.affiliations.form.paymentData;
    },
    quotation: function quotation(state) {
      return state.affiliations.form.quotation;
    },
    multiAdress: function multiAdress(state) {
      return state.affiliations.form.multiAdress;
    }
  }), {
    posName: function posName() {
      return this.posSelected.pos || null;
    },
    priceSoles: function priceSoles() {
      return this.posSelected.priceSoles || '';
    },
    priceDolares: function priceDolares() {
      return this.posSelected.priceDolares || 'null';
    },
    shipping: function shipping() {
      return this.posSelected.tarifas && this.posSelected.tarifas.shippingFull;
    },
    shippingSoles: function shippingSoles() {
      return this.posSelected.tarifas && this.posSelected.tarifas.shippingFullSoles;
    },
    renovation: function renovation() {
      return this.posSelected.tarifas && this.posSelected.tarifas.renovation;
    },
    renovationDolares: function renovationDolares() {
      return this.posSelected.tarifas && this.posSelected.tarifas.renovationDolares;
    },
    commercialTariffSoles: function commercialTariffSoles() {
      return this.commercialTariffResults.find(function (c) {
        return c.currency === currencyTypeEnum.SOLES;
      }) || false;
    },
    commercialTariffDolares: function commercialTariffDolares() {
      return this.commercialTariffResults.find(function (c) {
        return c.currency === currencyTypeEnum.DOLARES;
      }) || false;
    },
    isSoles: function isSoles() {
      return !!this.commercialTariffSoles.currency;
    },
    isDolares: function isDolares() {
      return !!this.commercialTariffDolares.currency;
    },
    affiliation: function affiliation() {
      if (this.commercialTariffSoles) return this.commercialTariffSoles.tariff.affiliation;
      if (this.commercialTariffDolares) return this.commercialTariffDolares.tariff.affiliation;
      return "";
    },
    affiliationComment: function affiliationComment() {
      if (this.commercialTariffSoles) return this.commercialTariffSoles.tariff.affiliationComment;

      if (this.commercialTariffDolares) return this.commercialTariffDolares.tariff.affiliationComment;
      return "";
    },
    equipmentCost: function equipmentCost() {
      if (this.commercialTariffSoles) {
        return this.commercialTariffSoles.tariff.equipmentCost;
      }
      if (this.commercialTariffDolares) {
        return this.commercialTariffDolares.tariff.equipmentCost;
      }
      return "";
    },
    equipmentCostComment: function equipmentCostComment() {
      if (this.commercialTariffSoles) {
        return this.commercialTariffSoles.tariff.equipmentCostComment;
      }
      if (this.commercialTariffDolares) {
        return this.commercialTariffDolares.tariff.equipmentCostComment;
      }
      return "";
    },
    maintenance: function maintenance() {
      if (this.commercialTariffSoles) {
        return this.commercialTariffSoles.tariff.maintenance;
      }
      if (this.commercialTariffDolares) {
        return this.commercialTariffDolares.tariff.maintenance;
      }
      return "";
    },
    maintenanceComment: function maintenanceComment() {
      if (this.commercialTariffSoles) {
        return this.commercialTariffSoles.tariff.maintenanceComment;
      }
      if (this.commercialTariffDolares) {
        return this.commercialTariffDolares.tariff.maintenanceComment;
      }
      return "";
    },
    platformUsageCE: function platformUsageCE() {
      if (this.commercialTariffSoles) {
        return this.commercialTariffSoles.tariff.platformUsageCE;
      }
      if (this.commercialTariffDolares) {
        return this.commercialTariffDolares.tariff.platformUsageCE;
      }
      return "";
    },
    platformUsageCEComment: function platformUsageCEComment() {
      if (this.commercialTariffSoles) {
        return this.commercialTariffSoles.tariff.platformUsageCEComment;
      }
      if (this.commercialTariffDolares) {
        return this.commercialTariffDolares.tariff.platformUsageCEComment;
      }
      return "";
    },
    renewal: function renewal() {
      if (this.commercialTariffSoles) {
        return this.commercialTariffSoles.tariff.renewal;
      }
      if (this.commercialTariffDolares) {
        return this.commercialTariffDolares.tariff.renewal;
      }
      return "";
    },
    renewalComment: function renewalComment() {
      if (this.commercialTariffSoles) {
        return this.commercialTariffSoles.tariff.renewalComment;
      }
      if (this.commercialTariffDolares) {
        return this.commercialTariffDolares.tariff.renewalComment;
      }
      return "";
    },
    isPagoLink: function isPagoLink() {
      return this.$virtualPosEnum.PAGO_LINK === this.$store.state.affiliations.form.posSelected.pos;
    },
    isPagoWeb: function isPagoWeb() {
      return this.$virtualPosEnum.PAGO_WEB === this.$store.state.affiliations.form.posSelected.pos;
    },
    isPagoApp: function isPagoApp() {
      return this.$virtualPosEnum.PAGO_APP === this.$store.state.affiliations.form.posSelected.pos;
    },
    maintenancePriceCost: function maintenancePriceCost() {
      return this.quotation.maintenancePriceCost || 0;
    },
    maintenancePriceCostDolar: function maintenancePriceCostDolar() {
      return this.quotation.maintenancePriceCostDolar || 0;
    },
    usePlatformWebCost: function usePlatformWebCost() {
      return this.posSelected.usePlatformWebCost || null;
    }
  }),
  methods: {
    onSubmit: function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var requestAffiliation, response, onHold;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:

                this.$v.$touch();
                if (this.multiAdress.length > 0) {
                  this.messageModal = 'Procesando Afiliaciones';
                }

                if (!(this.$v.invalid || this.loading)) {
                  _context.next = 4;
                  break;
                }

                return _context.abrupt("return");

              case 4:

                this.$refs.loaderModal.showLoader();

                _context.prev = 5;
                requestAffiliation = {
                  posName: this.posName,
                  price: this.price,
                  shipping: this.shipping,
                  renovation: this.renovation,
                  authorizePersonalDataTreatment: this.authorizePersonalDataTreatment,
                  maintenancePriceCost: this.maintenancePriceCost,
                  maintenancePriceCostDolar: this.maintenancePriceCostDolar,
                  usePlatformWebCost: this.usePlatformWebCost,
                  rentalSoles: this.priceSoles.replace(/\$|S\/| /g, ''),
                  rentalDolares: this.priceDolares.replace(/\$|S\/| /g, '')
                };

                console.log('affiliacion virtual: ', requestAffiliation);

                _context.next = 10;
                return this.$store.dispatch("affiliations/form/saveAfilliationSummary", requestAffiliation);

              case 10:
                response = _context.sent;


                console.log('response summary virtual: ', response);
                if (!response) {
                  this.$swal("Ocurri\xF3 un error al guardar la afiliaci\xF3n", Array.isArray(error.message) ? error.message.map(function (m) {
                    return "c\xF3digo: " + m.codigo + " - descripci\xF3n: " + m.descripcion;
                  }).join(",") : _JSON$stringify(error.message), "warning");
                }
                _context.next = 18;
                break;

              case 15:
                _context.prev = 15;
                _context.t0 = _context["catch"](5);

                if (_context.t0 instanceof ConflictError) {
                  this.$swal("Ocurri\xF3 un error al guardar la afiliaci\xF3n", Array.isArray(_context.t0.message) ? _context.t0.message.map(function (m) {
                    return "c\xF3digo: " + m.codigo + " - descripci\xF3n: " + m.descripcion;
                  }).join(",") : _JSON$stringify(_context.t0.message), "warning");
                } else {
                  this.$controlMessage(_context.t0);
                }

              case 18:

                this.$refs.loaderModal.closeLoader();

                onHold = this.$store.state.affiliations.form.onHold;

                if (onHold) {
                  _context.next = 29;
                  break;
                }

                _context.prev = 21;
                _context.next = 24;
                return this.$store.dispatch("affiliations/form/addCommerceCodeFile", {});

              case 24:
                _context.next = 29;
                break;

              case 26:
                _context.prev = 26;
                _context.t1 = _context["catch"](21);

                console.log('Error add commerceCode...', _context.t1);

              case 29:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[5, 15], [21, 26]]);
      }));

      function onSubmit() {
        return _ref.apply(this, arguments);
      }

      return onSubmit;
    }(),
    tableComissionClose: function tableComissionClose() {
      this.tableComision = false;
      this.dialog = false;
    }
  }
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/babel-loader/lib?{"babelrc":false,"cacheDirectory":true,"presets":[["/app/node_modules/babel-preset-vue-app/dist/index.common.js",{"targets":{"ie":9,"uglify":true}}]]}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/stepper/afilliation-summary-virtual.vue
// module id = ./node_modules/babel-loader/lib/index.js?{"babelrc":false,"cacheDirectory":true,"presets":[["/app/node_modules/babel-preset-vue-app/dist/index.common.js",{"targets":{"ie":9,"uglify":true}}]]}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/stepper/afilliation-summary-virtual.vue
// module chunks = 0 1 2 3